<template>
  <div class="">
    <div class="Back_click">
      <!-- 北京时间 -->
      <!-- 北京时间：{{ date | formatDate }} -->
      <span @click="$router.back(-1)">&lt;&nbsp;返回Node列表</span>
    </div>
    <el-tabs type="border-card" v-model="activeName" @tab-click="handleTabClick" style="margin-top:22px;">
      <el-tab-pane label="概述" name="first">
        <div class="bg-white ofh mb30">
          <div class="log">
            <div class="log-nav">

              <!-- <span style="width:53px;display:inline-block;" class="demonstration">开始：</span>
              <el-input style="width:210px;" placeholder="2019-01-01 00:00:00" suffix-icon="el-icon-date" v-model="form.date1"></el-input>
              <span style="width:53px;display:inline-block;margin-left:10px;" class="demonstration">结束：</span>
              <el-input style="width:210px;" placeholder="2019-01-02 00:00:00" suffix-icon="el-icon-date" v-model="form.date2"></el-input> -->
              <el-date-picker
                  v-model="form.date1"
                  type="datetime"
                  format="yyyy-MM-dd HH:mm:ss"
                  value-format="yyyy-MM-dd HH:mm:ss"
                  :editable = "false"
                  @change="changeDate"
                  style="width:220px;"
                  placeholder="选择开始日期">
              </el-date-picker>
              <el-date-picker
                  v-model="form.date2"
                  type="datetime"
                  format="yyyy-MM-dd HH:mm:ss"
                  value-format="yyyy-MM-dd HH:mm:ss"
                  :editable = "false"
                  @change="changeDate"
                  style="margin-left:10px;width:220px;"
                  placeholder="选择结束日期">
              </el-date-picker>
              <div style="margin-left:10px;">
                <el-input placeholder="请输入命令类别" v-model="form.keyWord">
                </el-input>
              </div>
              <div style="margin-left:10px;">
                <el-input placeholder="请输入节点ID" v-model="form.id">
                </el-input>
              </div>
              <div style="margin-left:10px;">
                <el-input placeholder="请输入packetID" v-model="form.packetid">
                </el-input>
              </div>
              <div style="margin-left:10px;">
                <el-input placeholder="请输入traceID" v-model="form.traceID">
                </el-input>
              </div>
              <div style="margin-left:10px;">
                <el-input placeholder="请输入packetNum" v-model="form.packetNum">
                </el-input>
              </div>
              <el-button style="margin-left:10px;" type="primary" @click="search">搜索</el-button>
            </div>
            <div class="content" v-loading="loading">
              <svg></svg>
            </div>
          </div>
        </div>
      </el-tab-pane>
      <el-tab-pane label="线程" name="second">
        <div class="bg-white ofh mb30">
          <div class="content clearfix content-vvv">
            <el-col class="left" v-loading="loading2">
              <ul id="ul-content">
                <li v-for="(item_list,index) in xcList" :class="item_list.threadState" @click="seeThread(index,item_list)">
                  <div class="">
                    <p>&ensp;{{item_list.threadName}}:{{item_list.threadState}}</p>
                    <p class="switcha" :class="{'active_p':item_list.showA==true}"></p>
                  </div>
                  <div class="div_fadein" v-show="item_list.showA">
                      <p v-for="(item,index) in xlList">&ensp;{{item}}</p>
                  </div>
                </li>
              </ul>
            </el-col>
            <el-col class="right">
              <el-form style="display: flex;" :rules="rules" :model="form">
                <el-form-item label="日期：" style="width: 34%;">
                  <el-date-picker
                    v-model="form.date"
                    style="width:210px;"
                    type="datetime"
                    :offset="1"
                    format="yyyy-MM-dd HH:mm:ss"
                    value-format="yyyy-MM-dd HH:mm:ss"
                    :editable = "false"
                    placeholder="选择日期">
                  </el-date-picker>
                </el-form-item>
                <el-form-item label="节点ID：" style="width: 30%;" prop="node">
                  <el-input style="width:210px;" placeholder="请输入Node ID" v-model.number="form.node"></el-input>
                </el-form-item>
                <el-form-item>
                  <el-button type="primary" style="margin-left:20px;" @click="search2">查询</el-button>
                </el-form-item>
              </el-form>
              <div class="content-right">
                <div class="content-right-absolute">
                  <span></span>&nbsp;运行&ensp;
                  <span></span>&nbsp;阻塞&ensp;
                  <span></span>&nbsp;等待&ensp;
                  <span></span>&nbsp;超时&ensp;
                </div>
              </div>
            </el-col>
          </div>
        </div>
      </el-tab-pane>
      <el-tab-pane v-if="node_type == 'node'" label="节点" name="third">
        <div class="bg-white ofh mb30">
          <div class="title-value" @click='eventStap'>
            <div class="chain-title-a">
              <!-- <el-time-picker 
                is-range
                v-model="form.date3"
                range-separator="to"
                start-placeholder="开始时间"
                end-placeholder="结束时间"
                placeholder="选择时间范围"
                style="width:410px">
              </el-time-picker> -->
              <el-date-picker
                v-model="form.date3"
                type="datetimerange"
                range-separator="to"
                start-placeholder="开始时间"
                end-placeholder="结束时间"
                style="width:410px">
              </el-date-picker>
              <!-- <el-date-picker style="width:392px;" v-model="form.date3" type="daterange" unlink-panels range-separator="to" start-placeholder="开始日期" end-placeholder="结束日期" value-format="yyyy-MM-dd"></el-date-picker> -->
              <el-select @change="changeBlock" style="width:150px;margin-left:10px;" v-model="typeValues" placeholder="请选择类型">
                <el-option
                  v-for="item in typeLists"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value">
                </el-option>
              </el-select>
              <!-- <el-input v-model="inputVal" placeholder="节点ID、地址" style="width:300px;border-radius:0 5px 5px 0;"></el-input>
              <el-button type="primary" @click="search" style="margin-left:10px;">搜索</el-button> -->
              <el-input placeholder="节点ID、地址" v-model="inputVal" class="input-with-select"  style="width:300px;border-radius:0 5px 5px 0;margin-left: 9px;">
                <el-button slot="append" icon="el-icon-search" @click="search"></el-button>
              </el-input>
            </div>
            <div id="Qknode">
              <p><img src="../../assets/images/history_u1.png" />&ensp;节点<b>{{routerQuery}}</b></p>
            </div>
            <div id="showNode">
              <ul>
      					<li><label for="">节点归属：</label><span>北京</span></li>
      					<li><label for="">节点地址：</label><span>{{nodeThings.nodeAddress}}</span></li>
      					<li><label for="">启动时间：</label><span>{{nodeThings.startTime}}</span></li>
      					<li><label for="">节点状态：</label><span>{{nodeThings.nodeState}}</span></li>
      			   </ul>
      			   <ul>
      					<li><label for="">统计截止时间：</label><span>{{time}}</span></li>
      					<li><label for="">创建区块数：</label><span>{{nodeThings.blockCount}}</span></li>
                <li><label for="">上链交易数：</label><span>{{nodeThings.tranCount}}</span></li>
      					<li><label for="">分区ID：</label><span>{{nodeThings.zoneID}}</span></li>
      			   </ul>
            </div>
            <div id="content">
              <div id="four_flash">
                <div id="NodeDIv">
                  <!-- <ul id="lll" class="mobile"> -->
                    <transition-group name="list" tag="ul" id="lll" class="mobile">
                      <!-- <li v-for="(item,index) in dataA"  @click="liStop(item.blockHash)" :key='item.blockHeight' class="list-item">{{item.blockHeight}}/{{index}}</li> -->
                      <li v-for="(item,index) in dataA" @click="liStop(item.blockHash,item.zoneId)" :key='item.blockHeight' class="list-item"><p></p><div style="line-height:70px;" :class="item.topA">
                        <p style="height:20px;line-height:3;">{{item.blockHeight}}</p>
                        <p style="height:20px;">{{item.zoneId}}</p>
                      </div></li>
                    </transition-group>
                    <!-- </ul> -->
                </div>
              </div>
              <div class="but_left" style="left:4%;"><img src="../../assets/images/prev.png" alt="左"/></div>
              <div class="but_right" style="right:8%;"><img src="../../assets/images/next.png" alt="右"/></div>
            </div>
            <div id="YzContent" @click="YzContent">
              <i>Block</i>
              <div id='YzContentP'>
                <p class="clearfix">
                  <label for="">计算难度</label>
                  <span>{{alertThings.difficulty}}</span>
                </p>
                <p class="clearfix">
                    <label for="">ID</label>
                    <span>{{alertThings.blockHash}}</span>
                </p>
                <p class="clearfix">
                  <label for="">打包时间</label>
                  <span>{{alertThings.packTime}}</span>
                </p>
                <p class="clearfix">
                  <label for="">验证节点</label>
                  <span>{{alertThings.blockProcess}}</span>
                </p>
              </div>
              <div class="jiaoyi_list"><p style="border-bottom:none;">交易列表</p></div>
              <ol class="jiaoyi_list_ol">
                <li @click="chainprocess(item)" v-for="item in alertThings.tranList">{{item}}</li>
                <!-- <li @click="chainprocess(item.height)" v-for="item in dataA">{{item.height}}</li> -->
              </ol>
            </div>
          </div>
        </div>
      </el-tab-pane>
    </el-tabs>
  </div>
</template>


<script>
  import $ from "jquery";
  import * as d3 from 'd3';
  export default {
    name: "dseed",
    data() {
      var validateNode = (rule, value, callback) => {
        console.log(typeof value)
        if (!Number.isInteger(value)) {
          callback(new Error('请输入数字值'));
        }else {
          callback();
        }
      };
      return {
        typeLists: [{
          value: '0',
          label: 'all'
        }, {
          value: '1',
          label: 'node'
        }, {
          value: '2',
          label: 'transaction'
        },
        {
          value: '3',
          label: 'empty'
        }],
        typeValues: '0',
        inputVal:'',
        nodeThings:'',
        node_type:this.$route.query.node_type,
        dataA:[

        ],
        nodeHash:'',
        dataB:[],
        time:'',
        alertThings:'',
        routerQuery:this.$route.query.nodes,
        activeName:this.$route.query.thread,
        form:{
          packetNum:'',
          traceID:'',
          date1:'',
          date2:'',
          date3:'',
          date4:'',
          keyWord:'',
          id:this.$route.query.nodeid,
          date:'',
          node:this.$route.query.nodeid,
          packetid:'',
        },
        xcList:[],
        xlList:[],
        loading: false,
        loading2: false,
        rules: {
          node: [
            { validator: validateNode,  trigger: 'blur' },
          ]
        }
      }
    },
    mounted(){
      this.getSvgTest();
      this.getBlock();
      this.getNode();
      // this.liStop();
      var date = new Date();
      var Y = date.getFullYear() + '-';
      var M = (date.getMonth()+1 < 10 ? '0'+(date.getMonth()+1) : date.getMonth()+1) + '-';
      var D = date.getDate() + ' ';
      var h = date.getHours() + ':';
      var m = date.getMinutes() + ':';
      var s = date.getSeconds();
      this.time = Y+M+D+h+m+s;
  
      this.timer = setInterval(this.search2,1000*60);
    },
    beforeDestroy:function(){
      if(this.timer){
        clearInterval(this.timer); //在Vue实例销毁前，清除我们的定时器
      }
      clearInterval(this.setInterval_ID);
    },
    destroyed:function(){
      var _this = this;
      window.clearInterval(_this.setInterval_ID)
    },
    methods: {
      /////////
      //跳转三级页
      chainprocess(e){
        this.$router.push({
          path:'/chainprocess',
          query:{'transaction':e}
        })
      },
      getNode(){
        let zoneid = this.routerQuery+','+this.$route.query.zoneid;
        let params = {
            nodeID:this.routerQuery,
            nodeHash:this.nodeHash,
        }
        params = this.$qs.stringify(params,{ indices: false });
        this.axios({
            method:'post',
            url:window.API_HOST+'/chain/findNodeInfo',
            data:params,
        }).then((res)=>{
          // console.log(1111);
          // console.log(res.data)
            this.nodeThings = res.data;
        })
      },
      YzContent(event){
        event.stopPropagation();
      },
      eventStap(){
        event.stopPropagation();
        $("#YzContent").css({"transform":"translateX(647px)","transition":"2s ease","display":"block !important"});
      },
      //搜索节点信息
      search(){
        var _this = this;

        var re = /^[0-9]+.?[0-9]*$/; //判断字符串是否为数字 //判断正整数 /^[1-9]+[0-9]*]*$/
        var nubmer = this.inputVal;
        if (!re.test(nubmer)) {
         this.nodeHash = nubmer;
         this.routerQuery = '';
        }else{
        this.nodeHash = '';
        this.routerQuery = nubmer;
        }
        this.getBlock();
        this.getNode();
      },
      liStop(a,zoneid){
        // event.stopPropagation();
        if(zoneid == '1'){
          return;
        }
        window.event? window.event.cancelBubble = true : e.stopPropagation();
        $("#YzContent").css({"transform":"translateX(0)","transition":"2s ease","display":"block"});
        let params = {
            blockHash:a,
            nodeId:this.routerQuery,
        }
        // params = Object.assign(params,this.form);
        params = this.$qs.stringify(params,{ indices: false });
        this.axios({
            method:'post',
            url:window.API_HOST+'/chain/findBlockInfo',
            data:params,
        }).then((res)=>{
            // console.log(res.data)
            this.alertThings = res.data;
        })
      },
      aaa(){
        console.log('3232323');
      },
      changeBlock(){
        this.getBlock();
      },
      //获取block信息
      getBlock(){
        var block;
        var _this = this;
        var d = new Date();
        window.clearInterval(_this.setInterval_ID)
        let zoneid = this.routerQuery+','+this.$route.query.zoneid;
        // console.log(this.form.date3[0]);
        //将时间转换为普通格式
        var d1 = new Date(this.form.date3[0]).toJSON();
        var ztime1 = new Date(+new Date(d1)+8*3600*1000).toISOString().replace(/T/g,' ').replace(/\.[\d]{3}Z/,'');
        // console.log(ztime1);
        // console.log(d1);
        if(d1 == null ){
          ztime1 = null;
        }
        var d2 = new Date(this.form.date3[1]).toJSON();
        var ztime2 = new Date(+new Date(d2)+8*3600*1000).toISOString().replace(/T/g,' ').replace(/\.[\d]{3}Z/,'')  
        if(d2 == null ){
          ztime2 = null;
        }
        let params = {
            type:this.typeValues,
            nodeId:zoneid,
            nodeHash:this.nodeHash,
            limit:'100',
            beginTime:ztime1,
            endTime:ztime2,
        }
        params = this.$qs.stringify(params,{ indices: false });
        this.axios({
            method:'post',
            url:window.API_HOST+'/chain/findBlockHeight',
            data:params,
        }).then((res)=>{
          if(JSON.stringify(res.data) != "{}"){
            var data = res.data.blockList;
            for (let i = 0; i < data.length; i++) {
              if(data[i].blockHash == "null"){
                data.splice(i,1);
              }
            }
            this.dataA = data;
            if(data.length>0){
              block = data[0].id;
              //  点击左右切换
                var _index5=0;
                $(".but_left").hide();
                  $(".but_right img").click(function(){
                      _index5++;
                      var len=$("ul.mobile li").length;
                      if(_index5+5>len || Math.floor(len / 7) == _index5){
                          // $(".but_right").hide();
                      }else{
                        $(".but_right").show();
                      };
                      if(_index5>0 && _index5<len){
                        $(".but_left").show();
                      }else{
                        $(".but_left").hide();
                      };
                      $("ul.mobile").stop().animate({left:-_index5*140*7},1000);
                    if(_index5 >= Math.floor(_this.dataA.length / 7)){
                      var blockId = $("#lll").find("li:last-child").attr("pid");
                      let params3 = {
                          type:'2',
                          nodeId:zoneid,
                          blockHeight:_this.dataA[_this.dataA.length-1].blockHeight,
                          limit:'7'
                      }
                      params3 = _this.$qs.stringify(params3,{ indices: false });
                      //将时间转换为普通格式
                      var d1 = new Date(this.form.date3[0]).toJSON();
                      var ztime1 = new Date(+new Date(d1)+8*3600*1000).toISOString().replace(/T/g,' ').replace(/\.[\d]{3}Z/,'');
                      if(d1 == null ){
                        ztime1 = null;
                      }
                      var d2 = new Date(this.form.date3[1]).toJSON();
                      var ztime2 = new Date(+new Date(d2)+8*3600*1000).toISOString().replace(/T/g,' ').replace(/\.[\d]{3}Z/,'')
                      if(d2 == null ){
                        ztime2 = null;
                      }  
                      _this.axios({
                          method:'post',
                          url:window.API_HOST+'/chain/findBlockHeight',
                          data:params3,
                          beginTime:ztime1,
                          endTime:ztime2,
                      }).then((res)=>{
                        if(JSON.stringify(res.data) != "{}"){
                          var data = res.data.blockList;
                            if(data != null){
                              for(let i=0;i<data.length;i++){
                                _this.dataA.push({'blockHeight':data[i].blockHeight});
                              }
                            };
                          }
                        })
        		    	}
        		    });
        		    $(".but_left img").click(function(){
        		    	$(".but_right").show();
        		        if(_index5==1){
        		            $(".but_left").hide();
        		        }else{
        		        	$(".but_left").show();
        		        }
        		        _index5--;
        		        $("ul.mobile").stop().animate({left:-_index5*140*7},1000);
        		    });
                window.clearInterval(_this.setInterval_ID)
        		    _this.setInterval_ID = setInterval(function () {
                  if(_this.dataA.length == "0"){
                    $(".but_right").hide();
                    return;
                  }
                  let zoneid = _this.routerQuery+','+_this.$route.query.zoneid;
                  let params2 = {
                      blockHeight:_this.dataA[0].blockHeight,
                      // nodeId:_this.routerQuery,
                      nodeId:zoneid,
                      type:_this.typeValues,
                  }
                  params2 = _this.$qs.stringify(params2,{ indices: false });
                  _this.axios({
                      method:'post',
                      url:window.API_HOST+'/chain/updateBlock',
                      data:params2,
                  }).then((res)=>{
                    var data = res.data.blockHeight;
                    var data2 = res.data.zoneId;
          						if(data != null){
          							block = data.id;
                        var b = {'blockHeight':data,'zoneId':data2,'classA':'new','topA':'topA'};
                        _this.dataA.splice(0,0,b);
          						};
                    })
                },15000);
                // },1000);
        	  	}else{
                $(".but_right").hide();
                $(".but_left").hide();
              }
          }
        });
      },
      /////////
      changeDate(){
        var time1 = this.form.date1;
        var time2 = this.form.date2;
        var dateSpan,
            tempDate,
            sDate1,
            sDate2;
          sDate1 = Date.parse(time1);
          sDate2 = Date.parse(time2);
          dateSpan = sDate2 - sDate1;
          dateSpan = Math.abs(dateSpan);
          var iDays = Math.floor(dateSpan / (24 * 3600 * 1000));
          var dayS = iDays + 1;
          // if(this.form.date1.length != 19 || this.form.date2.length != 19){
          //   this.$message.error("起止日期格式书写有误");
          //   return;
          // }
          // if(dayS > 10){
          //   this.$message.error("起止日期不得超过10天");
          //   return;
          // }
          this.current = '0';
          // this.YccxBt("1");
      },
      seeThread(e,val){
        val.showA = !val.showA;
        console.log(val.showA);
        this.$forceUpdate();
        var index = e;
        this.xlList = this.xcList[index].threadInfo;
        console.log(111);
      },
      aaa(){
          alert(1)
        },
      search2(){
        this.loading2 = true;
        console.log(this.form.date)
        let params = {
            queryTime:this.form.date,
            nodeID:this.form.node
        };
        // params = Object.assign(params,this.form);
        params = this.$qs.stringify(params,{ indices: false });
        var _this = this;
        this.axios({
            method:'post',
            url:window.API_HOST+'/node/selectNodeThread',
            data:params,
        }).then((res)=>{
          this.loading2 = false;
          if(res.data.threadInfo.length == "0"){
            this.$message({
              message: res.data.errorMsg,
              type: 'warning'
            });
            return;
          }
          document.getElementById("title-right").style.cssText = "top:10px !important;transition:1s all;-webkit-transition:1s all;";
          for (let i = 0; i < res.data.threadInfo.length; i++) {
            res.data.threadInfo[i].showA = false;
          }
          this.xcList = res.data.threadInfo;
          // this.xlList = this.xcList[0].threadInfo;
        })
      },
      handleTabClick(){
        if(this.activeName == "second"){
          this.search2();
        }
      },
      //测试代码
      getSvgTest(){
        this.loading = true;
        d3.select("svg").html("");
        let params = {
            cmdType:this.form.keyWord,//命令类别
            nodeid:this.form.id,
            begainTime:this.form.date1,
            endTime:this.form.date2,
            traceId:this.form.traceID,
            packetID:this.form.packetid,
            packetNum:this.form.packetNum,
        };
        params = this.$qs.stringify(params,{ indices: false });
        // var dataJson = Svg;
        this.axios({
            method:'post',
            url:window.API_HOST+'/node/getDpyJsonStr',
            data:params,
        }).then((res)=>{
          this.loading = false;
          if(Number(res.data.totalNum) > 200){
            this.$message({
              message: '元素个数已超过200，请添加搜索条件',
              type: 'warning'
            });
          }
        var str = '';
        var links = res.data.displayJsonStrList;
       
        for(let i = 0; i < res.data.displayJsonStrList.length; i++){
          str += res.data.displayJsonStrList[i];
        }
        //  console.log(str);
        // var links = [
        //   {"links":[
        //     {"source":997033,"target":1031449,"type":"to","toid":"'506'"},
        //     {"source":1031448,"target":997033,"type":"from","fromId":"'505'"},
        //     {"source":1032301,"target":1031449,"type":"to","toid":"'506'"},
        //     {"source":1031448,"target":1032301,"type":"from","fromId":"'505'"},
        //     {"source":1032310,"target":1031449,"type":"to","toid":"'506'"},
        //     {"source":1031448,"target":1032310,"type":"from","fromId":"'505'"},
        //     {"source":1032432,"target":1031448,"type":"to","toid":"'505'"},
        //     {"source":1031449,"target":1032432,"type":"from","fromId":"'506'"},
        //     {"source":1032439,"target":1031449,"type":"to","toid":"'506'"},
        //     {"source":1031448,"target":1032439,"type":"from","fromId":"'505'"}]
        //     ,
        //     "nodes":[
        //     {"traceID":"efa192c5-2195-483e-a7f7-f52aa3fba60a","toID":"506","forwardTimes":"0","cmdType":"buildCoinBaseTx","msgID":"af20920a-8487-4ed3-8ae9-d24ea3738915 -30458338 2019-07-02 20:59:35 465 57","txid":"","label":"packet","fromID":"505","tID":"efa192c5-2195-483e-a7f7-f52aa3fba60a","insertTime":"1562072713363","updTime":"2019-07-02 20:59:35 465","sendType":"echoPacket","mtxid":"","fromZoneID":"1049","toZoneID":"1049","id":"997033","type":"packet"},	
        //     {"label":"node","nodeType":"node","nodeid":"506","id":"1031449","type":"node"},	
        //     {"label":"node","nodeType":"node","nodeid":"505","id":"1031448","type":"node"},
        //     {"traceID":"26e84c85-2bcf-4963-a5c3-aafa5dc0df17","toID":"506","forwardTimes":"0","cmdType":"buildCoinBaseTx","msgID":"a78a6f80-a311-4bff-a6ac-dfb2d474456a -2132845094 2019-07-02 20:59:33 912 26","txid":"","label":"packet","fromID":"505","tID":"26e84c85-2bcf-4963-a5c3-aafa5dc0df17","insertTime":"1562072620408","updTime":"2019-07-02 20:59:33 912","sendType":"echoPacket","mtxid":"","fromZoneID":"1049","toZoneID":"1049","id":"1032301","type":"packet"},	
        //     {"label":"node","nodeType":"node","nodeid":"506","id":"1031449","type":"node"},	
        //     {"label":"node","nodeType":"node","nodeid":"505","id":"1031448","type":"node"},
        //     {"traceID":"0595df6c-8e3a-4917-a852-64ead039c148","toID":"506","forwardTimes":"0","cmdType":"buildCoinBaseTx","msgID":"da0051a9-c49e-4bfb-8b2c-4e82e1b80b12 832402890 2019-07-02 20:59:34 001 44","txid":"","label":"packet","fromID":"505","tID":"0595df6c-8e3a-4917-a852-64ead039c148","insertTime":"1562072621129","updTime":"2019-07-02 20:59:34 001","sendType":"echoPacket","mtxid":"","fromZoneID":"1049","toZoneID":"1049","id":"1032310","type":"packet"},	
        //     {"label":"node","nodeType":"node","nodeid":"506","id":"1031449","type":"node"},	
        //     {"label":"node","nodeType":"node","nodeid":"505","id":"1031448","type":"node"},
        //     {"traceID":"29bb5bae-96f1-47b8-848c-215d8142b2ac","toID":"505","forwardTimes":"0","cmdType":"buildCoinBaseTx","msgID":"c9b68fd9-6503-4657-992f-1215858faa0f 1304256537 2019-07-02 20:59:31 692 13","txid":"","label":"packet","fromID":"506","tID":"29bb5bae-96f1-47b8-848c-215d8142b2ac","insertTime":"1562072609391","updTime":"2019-07-02 20:59:31 692","sendType":"sendInZone","mtxid":"","fromZoneID":"1049","toZoneID":"1049","id":"1032432","type":"packet"},	
        //     {"label":"node","nodeType":"node","nodeid":"505","id":"1031448","type":"node"},	
        //     {"label":"node","nodeType":"node","nodeid":"506","id":"1031449","type":"node"},
        //     {"traceID":"29bb5bae-96f1-47b8-848c-215d8142b2ac","toID":"506","forwardTimes":"0","cmdType":"buildCoinBaseTx","msgID":"95f94d01-8eaf-4d3d-a220-9b4606e8831e 128131893 2019-07-02 20:59:32 664 72","txid":"","label":"packet","fromID":"505","tID":"29bb5bae-96f1-47b8-848c-215d8142b2ac","insertTime":"1562072610081","updTime":"2019-07-02 20:59:32 664","sendType":"echoPacket","mtxid":"","fromZoneID":"1049","toZoneID":"1049","id":"1032439","type":"packet"},	
        //     {"label":"node","nodeType":"node","nodeid":"506","id":"1031449","type":"node"},	
        //     {"label":"node","nodeType":"node","nodeid":"505","id":"1031448","type":"node"}]
        //     }
        // ];
      
        function GroupExplorer(data){
            var defaultConfig = {
                data:{"nodes":[],"links":[]},//critical data set
                windowWidth:window.innerWidth,
                windowHeight:window.innerHeight,
                defaultLinkDistance:150
            }
            $.extend(true,defaultConfig,data);
            var svg = d3.select("svg");
            svg.attr("width",defaultConfig.windowWidth);
            svg.attr("height",defaultConfig.windowHeight);
            defaultConfig.data.links.forEach(function(e){
                if(typeof e.source=="number"&&typeof e.target=="number"){
                    var sourceNode = defaultConfig.data.nodes.filter(function(n){
                        return n.id === e.source;
                    })[0];
                    var targetNode = defaultConfig.data.nodes.filter(function(n){
                        return n.id === e.target;
                    })[0];
                    e.source = sourceNode;
                    e.target = targetNode;
                }
            });
            var width = window.innerWidth,
                height = 800;
    var force = d3.layout.force()//layout将json格式转化为力学图可用的格式
        .nodes(d3.values(defaultConfig.data.nodes))//设定节点数组
        .links(defaultConfig.data.links)//设定连线数组
        .size([width, height])//大小
        .linkDistance(150)//连接线长度
        .charge(-1500)//值为+，则相互吸引，绝对值越大吸引力越大。值为-，则相互排斥，绝对值越大排斥力越大
        .on("tick", tick)//指时间间隔，隔一段时间刷新一次画面
        .start();//开始转换
    var zoom = d3.behavior.zoom()//缩放配置，
                .scaleExtent([0, 2])//缩放比例
                .on("zoom", zoomed);
        function zoomed(){//缩放函数
            svg.selectAll("g").attr("transform",//svg下的g标签移动大小
                    "translate("  +d3.event.translate + ")scale(" +d3.event.scale + ")");
                }
    var svg = d3.select("svg")//添加svg元素进行图形的绘制
        .attr("width", width)
        .attr("height", height)
        .call(zoom);
    //箭头
    var marker=//注意SVG规范中明确指出，附加到一个'Marker'元素上的“事件属性和事件的listener”不会被处理
        svg.append("marker")//添加一个marker标签来绘制箭头
        .attr("id", "resolved")//箭头id，用于其他标记进行引用时的url
        .attr("markerUnits","userSpaceOnUse")//定义标记的坐标系统，userSpaceOnUse表示按照引用的元件来决定，strokeWidth按照用户单位决定
        .attr("viewBox", "0 -5 12 10")//坐标系的区域
        .attr("refX",50)//箭头坐标
        .attr("refY", 0)
        .attr("markerWidth", 12)//标识的大小
        .attr("markerHeight", 12)
        .attr("orient", "auto")//绘制方向，可设定为：auto（自动确认方向）和 角度值
        .attr("stroke-width",2)//箭头宽度
        .append("path")
        .attr("d", "M0,-5L10,0L0,5")//绘制箭头，路径为一个三角形，有疑问参考svg的path http://www.runoob.com/svg/svg-path.html
        .attr('fill','#666');//箭头颜色
    //设置连接线
    var edges_line = svg.append("g").selectAll(".edgepath")
        .data(force.links())//连线数据
        .enter()//当数组中的个数大于元素个数时，由d3创建空元素并与数组中超出的部分进行绑定。
        //可以参考http://www.ourd3js.com/wordpress/797/ enter、exit、update的区别
        .append("path")//添加path标签
        .attr({
              'd': function(d) {return 'M '+d.source.x+' '+d.source.y+' L '+ d.target.x +' '+d.target.y},//变量 d 是由D3.js提供的一个在匿名函数中的可用变量。这个变量是对当前要处理的元素的_data_属性的引用。
              'class':'edgepath',//定义该path标签class为edgepath
              'id':function(d,i) {return 'edgepath'+i;}})// i也是d3.js提供的变量，表示当前处理的HTML元素在已选元素选集中的索引值
        .style("stroke","#666")//设置线条颜色
        .style("stroke-width",1)//线条粗细
        .attr("marker-end", "url(#resolved)" );//根据箭头标记的id号引用箭头
    //连线上的文字
    var edges_text = svg.append("g").selectAll(".edgelabel")
    .data(force.links())
    .enter()
    .append("text")//添加text标签
    .attr({  'class':'edgelabel',//定义该text标签class为edgelabel
           'id':function(d,i){return 'edgepath'+i;},
           'dx':60,//在连线上的坐标
           'dy':0
           });
    //设置线条上的文字路径
    edges_text.append('textPath')
    .attr('xlink:href',function(d,i) {return '#edgepath'+i})
    .style("pointer-events", "none")
    .text(function(d){
      return d.type;
    });
    function drag(){//拖拽函数
    return force.drag()
                .on("dragstart",function(d){
                    d3.event.sourceEvent.stopPropagation(); //取消默认事件
                    d.fixed = true;    //拖拽开始后设定被拖拽对象为固定
                });
                //.on("drag", dragmove);
                }
                //圆圈的提示文字 根据需要到数据库中进行读取数据
                var tooltip = d3.select("body")
                .append("div")//添加div并设置成透明
                .attr("class","tooltip")
                .style("opacity",0.0);
                //圆圈
                var circle = svg.append("g")
                    .selectAll("circle")
                    .data(force.nodes())//表示使用force.nodes数据
                    .enter().append("circle")
                    .style("fill",function(node){
                        var color="#68BDF6";//圆圈背景色
                        var link=defaultConfig.data.nodes[node.index];
                        if(link!=undefined){
                          if(link.type=='node'){
                              color="#6DCE9E";//F6E8E9
                          }else{
                              color="#68BDF6";
                          }
                        }
                        return color;
                    })
                    .style('stroke',function(node){ //
                        var color="#55B4F7";//圆圈边框的颜色
                        var link=defaultConfig.data.links[node.index];//
                        if(link!=undefined){
                          if(link.type=='node'){
                              color="#6DCE9E";
                          }else{
                              color="#68BDF6";
                          }
                        }
                        return color;
                    })
                    .attr("r", 40)//设置圆圈半径
                    .on("click",function(node){
                        //单击时让连接线加粗
                        edges_line.style("stroke-width",function(line){
                            if(line.source.name==node.name || line.target.name==node.name){//当与连接点连接时变粗
                                return 1;

                            }else{
                                return 1;
                            }
                        });
                        circle.style('stroke-width',1);//所有的圆圈边框
                        d3.select(this).style('stroke-width',2);//被选中的圆圈边框
                    })
                    .on("dblclick",function(d){
                        //双击节点时节点恢复拖拽
                        d.fixed = false;
                    })
                    .on("mouseover",function(d){
                      if(d.type == 'node'){
                        var nodeType = '';
                        if(d.nodeType == undefined){
                          nodeType = '';
                        }else{
                          nodeType = d.nodeType;
                        }
                        tooltip.html("nodeType：" + nodeType)
                            .style("left", (d3.event.pageX) + "px")
                            .style("top", (d3.event.pageY + 20) + "px")
                            .style("opacity",1.0);
                      }else{
                        tooltip.html("FromID：" +d.fromID+ "<br />" + "ToID：" +d.toID+ "<br />"+"id：" +d.id+ "<br />"+"sendType：" +d.sendType+ "<br />"+"type：" +d.type+ "<br />"+"cmdType：" +d.cmdType+ "<br />" +"updTime："+ d.updTime+ "<br />" +"traceID："+d.traceID)
                            .style("left", (d3.event.pageX) + "px")
                            .style("top", (d3.event.pageY + 20) + "px")
                            .style("opacity",1.0);
                      }
                    })
                    .on("mousemove",function(d){
                        tooltip.style("left", (d3.event.pageX) + "px")
                            .style("top", (d3.event.pageY + 20) + "px");
                    })
                    .on("mouseout",function(d){
                        tooltip.style("opacity",0.0);
                    })
                    .call(drag());//使顶点可以被拖动
                    svg.selectAll("g").call(drag());//为svg下的所有g标签添加拖拽事件
                    // svg.selectAll("circle").call(drag());
                    // svg.selectAll("path").call(drag());
                  svg.on("dblclick.zoom", );//取消svg和圆圈的双击放大事件（d3中默认开启7个事件，关闭防止与上面的双击事件冲突）
                  circle.on("dblclick.zoom", );
                var text = svg.append("g").selectAll("text")
                    .data(force.nodes())
                    //返回缺失元素的占位对象（placeholder），指向绑定的数据中比选定元素集多出的一部分元素。
                    .enter()
                    .append("text")//添加text标签
                    .attr("dy", ".35em") //将文字下移
                    .attr("text-anchor", "middle")//在圆圈中加上数据
                    .style('fill',function(node){
                        var color = '#FFF';//文字颜色
                        var link=defaultConfig.data.links[node.index];
                        console.log(link);
                        if(link!=undefined){
                          if(node.name==link.source.name){
                              color="#FFF";
                          }else{
                              color="#FFF";
                          }
                        }
                        return color;
                    }).attr('x',function(d){
                        var re_en = /[a-zA-Z]+/g;
                        d3.select(this).append('tspan')//添加tspan用来方便时使用绝对或相对坐标来调整文本
                             .attr('x',0)
                             .attr('y',2)
                             .text(function(){
                                if(d.fromID == undefined){
                                    return d.nodeid + d.nodeType;
                                }else{
                                    return d.id;
                                }
                            });

                    });
                    function tick() {//刷新页面函数
                      circle.attr("transform", transform1);//圆圈
                      text.attr("transform", transform1);//顶点文字
                      edges_line.attr('d', function(d) { //连接线
                          var path='M '+d.source.x+' '+d.source.y+' L '+ d.target.x +' '+d.target.y;
                          return path;
                      });
                      edges_text.attr('transform',function(d,i){//连线上的文字
                            if (d.target.x<d.source.x){//判断起点和终点的位置，来让文字一直显示在线的上方且一直是正对用户
                                var bbox = this.getBBox();//获取矩形空间,并且调整翻转中心。（因为svg与css中的翻转不同，具体区别可看http://www.zhangxinxu.com/wordpress/2015/10/understand-svg-transform/）
                                var rx = bbox.x+bbox.width/2;
                                var ry = bbox.y+bbox.height/2;
                                return 'rotate(180 '+rx+' '+ry+')';
                            }
                            else {
                                return 'rotate(0)';
                            }
                       })
                      .attr('dx',function(d,i){
                        return Math.sqrt(Math.pow(d.target.x-d.source.x,2)+Math.pow(d.target.y-d.source.y,2))/2-20;
                        //设置文字一直显示在线的中间

                      });
                    }
                    //设置圆圈和文字的坐标
                    function transform1(d) {
                      return "translate(" + d.x + "," + d.y + ")";
                    }
            }
            //because in the way of creating a javascript object,
            //you need to use "new" to use it
            new GroupExplorer({data:JSON.parse(str)});

      })
      },
      
      //查找
      search(){
        this.getSvgTest();
      }
    },

  };
</script>
<style lang="scss" scoped>
@import "../../assets/css/Border.css";
@import '../../assets/css/block.css';

/////
.list-item {
// display: inline-block;
margin-right: 10px;
}
.list-enter-active, .list-leave-active {
transition: all 1s;
}
.list-enter, .list-leave-to
/* .list-leave-active for below version 2.1.8 */ {
opacity: 0;
transform: translateY(120px);
}
  // #lll li.new{
  // 	width: 0;
  // }
  // #lll li.new>div{
  //   top: 100%;
  // }
  .title-value{
    background: #FFF;
    position: relative;
    overflow: hidden;
    .chain-title-a{
      text-align: center;
      padding:20px 0;
    }
  }
/////
.div_fadein{
  padding: 15px 0;
  animation: mymove 1s;
}
@keyframes mymove
{
  0% {opacity: 0}
  25% {opacity: 0.25}
  50% {opacity: 0.50}
  75% {opacity: 0.75}
  100% {opacity: 1}
}
.active_p{
  transform: rotate(135deg) !important;
}
#ul-content{
  li{
    position: relative;
    .switcha{
      position: absolute;
      z-index: 999;
      right: 15px;
      top: 11px;
      transition: 1s all;
    }
  }
}
.switcha{
  content: '';
   display: inline-block;
   width: 8px;
   height: 8px;
   border-top: 1px solid #656565;
   border-right: 1px solid #656565;
   transform: rotate(45deg);
   -webkit-transform: rotate(45deg);
}
.Back_click{
  cursor: pointer;
  color: #1385F9;
}
.content-vvv{
  position: relative;
}
.RUNNABLE{
  background: #3AE467;
}
.BLOCKED{
  background: #9B86DD;
}
.WAITING{
  background: #FFE45A;
}
.TIMED_WAITING{
  background: #E6801E;
}
.content-thread{
  margin-top: 0 !important;
  position: relative;
  background-color: #FFF;
  -webkit-box-shadow: #B7C7FF 0px 0px 20px;
  min-height: 700px;
  height: 700px;
  box-shadow: #B7C7FF 0px 0px 20px;
}
.right{
  width: 60%;
  .title-right{
    position: absolute;
    width: 73%;
    background: #FFF;
    text-align: center;
    height: 40px;
  }

  .content-right{
    margin-top: 53px;
    padding-left: 50px;
    padding-top: 20px;
    .content-right-absolute{
      position: absolute;
      font-size: 12px;
      bottom: 1px;
      right: 20px;
      span{
        display: inline-block;
        width: 17px;
        height: 8px;
      }
      span:first-child{
        background: #3AE467;
      }
      span:nth-child(2){
        background: #9B86DD;
      }
      span:nth-child(3){
        background: #FFE45A;
      }
      span:nth-child(4){
        background: #E6801E;
      }
    }
    p{
      margin: 8px 0;
    }
  }
}
.left{
  background: #FFF;
  border-right: 1px solid #EEE;
  margin-top: 68px;
  ul{
    li{
      div:first-child{
        height: 30px;
        line-height: 30px;
      }
      div:last-child{
        background: #FFF;
      }
    }
    // li:nth-child(2n+1){

    // }
    li:hover{
      cursor: pointer;
      div:last-child{
        background: #FFF !important;
        color: #000 !important;
      }
    }
  }
}

.log {
  background: #ffffff;
  .log-flex {
    display: flex;
    align-items: center;
  }
  .log-nav {
    // padding: 30px 0;
    display: flex;
    align-items: center;
    // border-bottom: 1px solid #dcdfe6;
  }
  .log-info {
    padding: 10px 0;
  }
  .paging {
    display: flex;
    justify-content: flex-end;
    padding: 20px;
  }
}
.chain-title-a1{
    margin-right: 20px;
    display: flex;
    justify-content: center;
    margin-left: 282px;
}
</style>
